export default "/search-eye-line.3bc5ac1c38d396cc595da391b7614b01.svg";